import { create } from 'zustand';
import { addMonths, currentMonthSP, type Ym } from '@lira/shared';

interface MonthState {
  month: Ym;
  /** direção da última navegação (para animar o slide do conteúdo). */
  direction: 1 | -1;
  setMonth: (m: Ym) => void;
  step: (delta: number) => void;
  goToday: () => void;
}

/** Mês selecionado global — TUDO no app pivota nele. */
export const useMonthStore = create<MonthState>((set, get) => ({
  month: currentMonthSP(),
  direction: 1,
  // Ym é 'YYYY-MM' de largura fixa → comparação lexicográfica define a direção do slide.
  setMonth: (month) => set((s) => ({ month, direction: month >= s.month ? 1 : -1 })),
  step: (delta) => set({ month: addMonths(get().month, delta), direction: delta >= 0 ? 1 : -1 }),
  goToday: () =>
    set((s) => ({ month: currentMonthSP(), direction: currentMonthSP() >= s.month ? 1 : -1 })),
}));
